<template>
  <div class="xn-table">
    <table>
      <thead>
        <tr>
          <th colspan="4">{{ cashflowDetail?cashflowDetail.companyName:'' }}</th>
        </tr>
        <tr>
          <th></th>
          <th>项目</th>
          <th style="width:30%">本年累计金额(元)</th>
          <th style="width:25%">本月金额(元)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tr,index) in tableConfig" :key="index" :class="tr.className">
          <td>{{ tr.col1 }}</td>
          <td>{{ tr.col2 }}</td>
          <td style="width:30%">{{ tr.col3 ? tr.col3.toLocaleString() : '-' }}</td>
          <td style="width:25%">{{ tr.col4 ? tr.col4.toLocaleString() : '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "CashflowDetail",
    computed: {
      ...mapGetters(['cashflowDetail']),
      id() {
        return this.$route.params.cashflowId;
      },
      item() {
        return this.cashflowDetail || {};
      },
      tableConfig() {
        let data = [
          // {className: 'header', col1: '', col2: '项目', col3: '本年累计金额(元)', col4: '本月金额(元)'},
          {className: 'bold', col1: '', col2: '一、经营活动产生的现金流量', col3: ' ', col4: ' '},
          {className: '', col1: '1', col2: '销售产成品、商品、提供劳务收到的现金', col3: this.item.c1, col4: this.item.r1},
          {className: '', col1: '2', col2: '收到其他与经营活动有关的现金', col3: this.item.c2, col4: this.item.r2},
          {className: '', col1: '3', col2: '购买原材料、商品、接受劳务支付的现金', col3: this.item.c3, col4: this.item.r3},
          {className: '', col1: '4', col2: '支付的职工薪酬', col3: this.item.c4, col4: this.item.r4},
          {className: '', col1: '5', col2: '支付的税费', col3: this.item.c5, col4: this.item.r5},
          {className: '', col1: '6', col2: '支付其他与经营活动有关的现金', col3: this.item.c6, col4: this.item.r6},
          {className: '', col1: '7', col2: '经营活动产生的现金流量净额', col3: this.item.c7, col4: this.item.r7},
          {className: 'bold', col1: '', col2: '二、投资活动产生的现金流量', col3: ' ', col4: ' '},
          {className: '', col1: '8', col2: '收回短期投资、长期债券投资和长期股权投资收到的现金', col3: this.item.c8, col4: this.item.r8},
          {className: '', col1: '9', col2: '取得投资收益收到的现金', col3: this.item.c9, col4: this.item.r9},
          {className: '', col1: '10', col2: '处置固定资产、无形资产和其他非流动资产收回的现金净额', col3: this.item.c10, col4: this.item.r10},
          {className: '', col1: '11', col2: '短期投资、长期债券投资和长期股权投资支付的现金', col3: this.item.c11, col4: this.item.r11},
          {className: '', col1: '12', col2: '购建固定资产、无形资产和其他非流动资产支付的现金', col3: this.item.c12, col4: this.item.r12},
          {className: '', col1: '13', col2: '投资活动产生的现金流量净额', col3: this.item.c13, col4: this.item.r13},
          {className: 'bold', col1: '', col2: '三、筹资活动产生的现金流量', col3: ' ', col4: ' '},
          {className: '', col1: '14', col2: '取得借款收到的现金', col3: this.item.c14, col4: this.item.r14},
          {className: '', col1: '15', col2: '吸收投资者投资收到的现金', col3: this.item.c15, col4: this.item.r15},
          {className: '', col1: '16', col2: '偿还借款本金支付的现金', col3: this.item.c16, col4: this.item.r16},
          {className: '', col1: '17', col2: '偿还借款利息支付的现金', col3: this.item.c17, col4: this.item.r17},
          {className: '', col1: '18', col2: '分配利润支付的现金', col3: this.item.c18, col4: this.item.r18},
          {className: '', col1: '19', col2: '筹资活动产生的现金流量净额', col3: this.item.c19, col4: this.item.r19},
          {className: 'bold', col1: '20', col2: '四、现金净增加额', col3: this.item.c20, col4: this.item.r20},
          {className: '', col1: '21', col2: '加：期初现金余额', col3: this.item.c21, col4: this.item.r21},
          {className: 'bold', col1: '22', col2: '五、期末现金余额', col3: this.item.c22, col4: this.item.r22},

        ];
        return data;
      }
    },
    methods: {
      ...mapActions(['getCashflowDetail'])
    },
    watch: {
      cashflowDetail() {
        if (this.cashflowDetail) {
          let arr = this.cashflowDetail.month.split('-');
          window.document.title = `${arr[0]}年${arr[1]}月报表`;
        }
      }
    },
    created() {
      this.getCashflowDetail(this.id);
    }
  }
</script>

<style scoped>

</style>